// extracted by mini-css-extract-plugin
export var section = "index-module--section--3rr6h";
export var mainTitle = "index-module--mainTitle--3bPGg";
export var mainDescription = "index-module--mainDescription--1ki0j";
export var menuContainer = "index-module--menuContainer--KMRx3";
export var menuItem = "index-module--menuItem--2cUhc";
export var menubar = "index-module--menubar--1xnCM";
export var cardsContainer = "index-module--cardsContainer--3QL-L";
export var nextPageButtonButton_container = "index-module--nextPageButtonButton_container--14tpE";
export var nextPageButtonButton = "index-module--nextPageButtonButton--1H7Nu";